module.exports = __webpack_public_path__ + "static/media/d7.6f3155da.jpg";